import React from 'react'

import { FiChevronRight, FiChevronDown } from 'react-icons/fi'

import { button } from './Button.module.scss'
import { over900 } from '~css/breakpoints.module.scss'

const Button = ({
  enabled,
  microcopy,
  explorer,
  endpoint,
  offset,
  onClick
}) => (
  <>
    { enabled && endpoint.showExplorer && process.env.GATSBY_FEATURE_EXPLORER === 'true' && (
      <button 
        onClick={onClick} 
        className={[button, over900].join(' ')}
        data-enabled={explorer.enabled}
        data-offset={offset}
        aria-label={ microcopy.text('explorer.buttons.try') }
      >
        { microcopy.text('explorer.buttons.try') }
        { explorer.enabled ? <FiChevronDown /> : <FiChevronRight/> }
      </button>
    )}
  </>
)

export default Button